import React from "react";
import Hero from "../components/landing/Hero";
import TrustMarquee from "../components/landing/TrustMarquee";
import StatsBar from "../components/landing/StatsBar";
import CertificationCard from "../components/landing/CertificationCard";
import Modules from "../components/landing/Modules";
import ROI from "../components/landing/ROI";
import Instructor from "../components/landing/Instructor";
import Testimonials from "../components/landing/Testimonials";
import WhoIsFor from "../components/landing/WhoIsFor";
import PracticalClass from "../components/landing/PracticalClass";
import CinematicView from "../components/landing/CinematicView";
import FinalOffer from "../components/landing/FinalOffer";
import FAQ from "../components/landing/FAQ";
import VSLSection from "../components/landing/VSLSection";
import FinalPush from "../components/landing/FinalPush";
import Footer from "../components/landing/Footer";
import StickyCTA from "../components/landing/StickyCTA";
import ExitIntentPopup from "../components/landing/ExitIntentPopup";

export default function LandingPage() {
  return (
    <main className="bg-[#0A0A0A] text-white font-body min-h-screen overflow-x-hidden">
      <CinematicView />
      <Hero />
      <TrustMarquee />
      <StatsBar />
      <CertificationCard />
      <Modules />
      <ROI />
      <Instructor />
      <Testimonials />
      <WhoIsFor />
      <PracticalClass />
      <FinalOffer />
      <FAQ />
      <VSLSection />
      <FinalPush />
      <Footer />
      <StickyCTA />
      <ExitIntentPopup />
    </main>
  );
}
